import { Controller } from '@hotwired/stimulus'
import $ from 'jquery'
import 'bootstrap-datepicker'
import {
  generatePresignedUrl,
  uploadFileInForm,
  areAllFilesUploaded,
} from '../../modules/s3_uploader'
import { loadPhoneInput, validateInput } from '../../modules/phone_input'

export default class extends Controller {
  static targets = [
    'phoneInput',
    'validMsg',
    'errorMsg',
    'kycForm',
    'onlyBirthyear',
    'birthyearInput',
  ]

  connect() {
    window.addEventListener('load', () => this._loadPhoneInput())

    this._loadPhoneInput()
    this._handleFileUploadSize()
    this._handleGeneratePresignedUrl()

    if (this.hasKycFormTarget) {
      this.kycFormTarget.addEventListener('submit', this.submitForm.bind(this))
    }

    $('.datepicker').datepicker({
      format: 'dd/mm/yyyy',
      autoclose: true,
    })

    // The birthyear toggle isn't present on every variant (e.g. the SG form).
    if (this.hasOnlyBirthyearTarget && this.hasBirthyearInputTarget) {
      this.onlyBirthyearTarget.addEventListener('change', () => {
        if (this.onlyBirthyearTarget.checked) {
          this.birthyearInputTarget.classList.remove('d-none')
        } else {
          this.birthyearInputTarget.querySelector('input').value = ''
          this.birthyearInputTarget.classList.add('d-none')
        }
      })
    }
  }

  _handleGeneratePresignedUrl() {
    document.querySelectorAll('input[type=file]').forEach((fileInput) => {
      fileInput.addEventListener('change', function (e) {
        generatePresignedUrl('director_kycs/', e.target)
      })
    })
  }

  _loadPhoneInput() {
    if (this.iti) return
    if (!this.hasPhoneInputTarget) return
    this.iti = loadPhoneInput(
      this.phoneInputTarget,
      this.data.get('country'),
      this.errorMsgTarget,
      this.validMsgTarget
    )
  }

  _handleFileUploadSize() {
    document.querySelectorAll('input[type=file]').forEach((fileInput) => {
      fileInput.addEventListener('change', function () {
        const selectedFile = fileInput.files[0]
        if (!selectedFile) return

        const fileSize = selectedFile.size // in bytes
        const maxSize = 25 * 1024 * 1024 // 25MB in bytes

        if (fileSize >= maxSize) {
          alert(
            'File size exceeds the maximum allowed size of 25MB. Please select a smaller file.',
          )

          fileInput.value = ''
        }
      })
    })
  }

  _validateInput() {
    if (!this.hasPhoneInputTarget) return true
    return validateInput(
      this.iti,
      this.phoneInputTarget,
      this.errorMsgTarget,
      this.validMsgTarget
    )
  }

  submitForm(e) {
    const self = this
    const form = self.kycFormTarget

    var isValid = self._validateInput()
    if (!isValid) {
      e.preventDefault()
      return
    }

    if (areAllFilesUploaded(form)) {
      return
    }

    e.preventDefault()
    form.submit.disabled = true

    uploadFileInForm(form, () => {
      form.submit.disabled = false
      form.submit.click()
    })
  }
}
